import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import * as React from "react";


interface ICustomModalProps {
    title?: string;
    content?: () => React.ReactNode;
    cancelButton: string;
    confirmButton?: string;
    open: boolean;
    onClose: Function;
    onCancel?: Function;
    callback?: Function;
    titleIcon?: React.ReactNode;
    disableButton?: boolean;
}


function CustomModal(props: ICustomModalProps) {

    return (<>
            {props.open && <Dialog open={props.open} fullWidth={true} maxWidth='md'  onClose={() => {
                props.onClose()
            }}>
                <DialogTitle sx={{borderBottom:'0px'}}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        {props.titleIcon}
                        <Typography fontWeight={"bold"} color={"primary"}>
                            {props.title}
                        </Typography>
                    </Box>
                </DialogTitle>
                {props.content &&
                    <DialogContent>
                        {props.content()}
                    </DialogContent>
                }

                <DialogActions>
                    <Button variant={props.confirmButton ? "outlined" : "contained"} color={"accent"} onClick={() => {
                        if (props.onCancel) {
                            props.onCancel();
                        }
                        props.onClose()
                    }}>{props.cancelButton}</Button>
                    {props.callback && <Button color={"accent"} disabled={props.disableButton} onClick={() => {
                        props.onClose();
                        if (props.callback) {
                            props.callback();
                        }
                    }}>{props.confirmButton}</Button>}
                </DialogActions>
            </Dialog>}
        </>
    )
}

export default CustomModal;